import { render, staticRenderFns } from "./file-delete.vue?vue&type=template&id=ad29e132&scoped=true"
import script from "./file-delete.vue?vue&type=script&lang=js"
export * from "./file-delete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad29e132",
  null
  
)

export default component.exports